var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_3890)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.4932 11.2666C26.0932 5.10659 20.7199 2.33325 15.9999 2.33325C15.9999 2.33325 15.9999 2.33325 15.9865 2.33325C11.2799 2.33325 5.89322 5.09325 4.49322 11.2533C2.93322 18.1333 7.14655 23.9599 10.9599 27.6266C12.3732 28.9866 14.1866 29.6666 15.9999 29.6666C17.8132 29.6666 19.6266 28.9866 21.0266 27.6266C24.8399 23.9599 29.0532 18.1466 27.4932 11.2666ZM15.9999 17.9466C13.6799 17.9466 11.7999 16.0666 11.7999 13.7466C11.7999 11.4266 13.6799 9.54658 15.9999 9.54658C18.3199 9.54658 20.1999 11.4266 20.1999 13.7466C20.1999 16.0666 18.3199 17.9466 15.9999 17.9466Z",
    fill: "#3D3D3D",
    fillOpacity: 0.3
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_3890"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.9456f0f76a7c0e70d746e9d989e6eb8a.svg";
export { ForwardRef as ReactComponent };